import {
  OfferSource,
  SectionItems,
  SectionStyleType,
  Typenames,
} from '@varo/graphql-schema-types';
import { router } from 'expo-router';
import { INCENTIVE_PARAM } from 'features/rewards/constants/constants';

export const sectionHeaderOnPress = (
  sectionId: string,
  sectionName: string,
  sectionStyle: SectionStyleType,
) => {
  if (sectionStyle === SectionStyleType.NearbySection) {
    router.push('/rewards/nearby-offers/map');
  } else {
    router.push({
      pathname: '/rewards/categories/[category]',
      params: {
        category: sectionId,
        name: sectionName,
        hidePills: 'true',
      },
    });
  }
};

export const rewardsActionNavigation = (
  sectionItem: SectionItems,
  sectionName?: string,
  coordinates?: google.maps.LatLngLiteral,
) => {
  const actionType = sectionItem?.onClick?.__typename;
  if (actionType === Typenames.SDPartnerReferralNavigationAction) {
    router.push({
      pathname: '/myvaro/referrals',
    });
  } else if (actionType) {
    if (
      sectionItem.offerSource === OfferSource.Upside &&
      sectionItem.merchantId
    ) {
      router.push({
        pathname: '/rewards/upside-offers/[merchantId]',
        params: {
          offerid: sectionItem.id,
          merchantId: sectionItem.merchantId,
          ...(coordinates && {
            lat: coordinates.lat.toString(),
            lng: coordinates.lng.toString(),
          }),
        },
      });
    } else {
      router.push({
        pathname: '/rewards/[id]',
        params: {
          id: sectionItem.id,
          ...(sectionName && {
            sectionName: sectionName,
          }),
          ...(actionType === Typenames.SDPartnerIncentivesNavigationAction && {
            style: INCENTIVE_PARAM,
          }),
        },
      });
    }
  }
};
